import { clsx } from "clsx";
import type { ReactNode } from "react";

export type SectionPad = "compact" | "default" | "band" | "page";

/**
 * Full-width page section with the sanctioned vertical rhythm.
 * Steps map to the --spacing-section-* tokens in globals.css:
 *
 * - `compact` — 20/28px (Regions)
 * - `default` — 20/32px (standard marketing section)
 * - `band`    — 40px flat (CtaBand)
 * - `page`    — 40/56px (simple page tops: reset-password, my-results)
 *
 * Backgrounds, scroll margins, etc. come in via `className`. The homepage
 * Hero keeps its own bespoke padding — see Hero.tsx.
 */
const padClass: Record<SectionPad, string> = {
  compact: "py-section-xs sm:py-section-sm",
  default: "py-section-xs sm:py-section-md",
  band: "py-section-lg",
  page: "py-section-lg sm:py-section-xl",
};

export function Section({
  pad = "default",
  id,
  className,
  children,
}: {
  pad?: SectionPad;
  id?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <section id={id} className={clsx(padClass[pad], className)}>
      {children}
    </section>
  );
}
